<template>
    <div class="home">
        <div class="home--header">
            <div class="home--header--inner">
                <img src="img/weinerlebnis_2026_titel_app.jpg?v=1" alt="WeinErlebnis 2026">
            </div>
        </div>
        <div class="home--content">
            <h1>Weinerlebnis Landau | Südliche Weinstrasse</h1>
            <h2>in Landau in der Pfalz am 05. & 06. Juni 2026</h2>
            <p>
                In der WeinerlebnisApp finden Sie alle Informationen zu dem Event. Stellen Sie sich Ihre eigenen Weinlisten zusammen.
            </p>

            <p>
                Versehen Sie Ihre Lieblingsweine mit Notizen und senden Sie diese per E-mail an sich und an Freunde.
            </p>

            <p>
                <strong>Um die APP optimal nutzen zu können, fügen Sie sie dem Startbildschirm hinzu.</strong>
            </p>
        </div>
        <card-container title="Weinsuche" src="img/teaser-weinsuche2.jpg" route="/weinsuche">
            Welche Weine wollen Sie verkosten. Stellen Sie sich Ihre Merkliste zusammen, damit Sie keinen für Sie interessanten Wein verpassen.
        </card-container>
        <card-container title="Wichtige Informationen" src="img/teaser-info3.jpg" route="/informationen">
            Öffnungszeiten, Preise und Kontaktdaten
        </card-container>
        <card-container title="Feedback" src="img/teaser-feedback2.jpg" route="/feedback">
            Bitte geben Sie uns Ihre Rückmeldung zu unserer neuen WeinAPP
        </card-container>
    </div>
</template>

<script>
    import IconArrow from "../components/icons/IconArrow";
    import CardContainer from "../components/CardContainer";

    export default {
        name: "Home",

        components: {
            CardContainer,
            IconArrow
        }
    }
</script>

<style lang="scss">
    .home--header {
    }

    .home--header--inner {
        max-width: $app-width;
        margin: 0 auto;
        padding: 0;

        img {
            width: 100%;
            margin: 0 auto;
            display: block;
        }
    }

    .home--header--logo {
        display: block;
        width: 266px;
        height: 159px;
        margin: 0 auto;
    }

    .home--content {
        width: $content-width;
        margin: 30px auto;
        text-align: center;
    }
</style>
